import { render, staticRenderFns } from "./AddUpdateKnowledgeContent.vue?vue&type=template&id=c7ad54a4&"
import script from "./AddUpdateKnowledgeContent.vue?vue&type=script&lang=js&"
export * from "./AddUpdateKnowledgeContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports